import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MLMProvider } from './context/MLMContext';
import { AdminProvider } from './context/AdminContext';
import { ThemeProvider } from './context/ThemeContext';

import './landing/index.css';
import './landing/App.css';
import { LangProvider } from './landing/context/LangContext';
import { HomePage } from './landing/App';
import LandingNosotros from './landing/pages/Nosotros';
import LandingContacto from './landing/pages/Contacto';
import LandingMercadosEmergentes from './landing/pages/MercadosEmergentes';
import LandingCentroAyuda from './landing/pages/CentroAyuda';
import LandingLegalesGenerales from './landing/pages/LegalesGenerales';
import LandingPrivacidad from './landing/pages/Privacidad';
import LandingTerminosCondiciones from './landing/pages/TerminosCondiciones';
import LandingCookies from './landing/pages/Cookies';
import LandingEnviosDevoluciones from './landing/pages/EnviosDevoluciones';
import LandingCodigoEtica from './landing/pages/CodigoEtica';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/admin/layout/AdminLayout';
import StoreLayout from './components/store/StoreLayout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Network from './pages/Network';
import Commissions from './pages/Commissions';
import Profile from './pages/Profile';
import RegisterPremium from './pages/RegisterPremium';
import RegisterGestor from './pages/RegisterGestor';
import SetPassword from './pages/SetPassword';

import AdminDashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/Users';
import AdminNetworkView from './pages/admin/NetworkView';
import CommissionSettings from './pages/admin/Commissions';
import PayoutManagement from './pages/admin/Payouts';
import ProductManagement from './pages/admin/Products';
import AdminCategories from './pages/admin/Categories';
import AdminSubcategories from './pages/admin/Subcategories';
import AdminFamilies from './pages/admin/Families';
import AdminPacks from './pages/admin/Packs';
import AdminOrders from './pages/admin/Orders';
import SystemReports from './pages/admin/Reports';
import SystemSettings from './pages/admin/Settings';

import MLMDashboard from './pages/mlm/MLMDashboard';
import BinaryTree from './pages/mlm/BinaryTree';
import UnilevelTree from './pages/mlm/UnilevelTree';
import RankProgression from './pages/mlm/RankProgression';
import WalletPage from './pages/mlm/WalletPage';
import SttoraPointsPage from './pages/mlm/SttoraPointsPage';
import GlobalPoolPage from './pages/mlm/GlobalPoolPage';
import AdminMLM from './pages/admin/AdminMLM';
import UserNetworkView from './pages/admin/UserNetworkView';
import StoreHome from './pages/store/StoreHome';
import CategoryProducts from './pages/store/CategoryProducts';
import ProductDetail from './pages/store/ProductDetail';
import Cart from './pages/store/Cart';
import Checkout from './pages/store/Checkout';
import StripeCheckout from './pages/store/StripeCheckout';
import OrderConfirmation from './pages/store/OrderConfirmation';
import OrderHistory from './pages/store/OrderHistory';
import AllCategories from './pages/store/AllCategories';
import FeaturedProducts from './pages/store/FeaturedProducts';
import SearchResults from './pages/store/SearchResults';
import StorePacks from './pages/store/Packs';
import StorePackDetail from './pages/store/PackDetail';

function PasswordGate({ children }) {
  const PASS = 'Sttora2026!';
  const [ok, setOk] = React.useState(sessionStorage.getItem('sttora-preview') === '1');
  const [val, setVal] = React.useState('');
  const [err, setErr] = React.useState(false);

  function check() {
    if (val === PASS) { sessionStorage.setItem('sttora-preview', '1'); setOk(true); }
    else { setErr(true); setVal(''); }
  }

  if (ok) return children;

  return (
    <div style={{ minHeight:'100vh', background:'#151A20', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'1.5rem', fontFamily:'Inter, sans-serif' }}>
      <img src="/assets/sttora-logo-web.png" alt="Sttora" style={{ height:'52px', opacity:0.9 }} />
      <p style={{ color:'rgba(249,250,246,0.4)', fontSize:'13px', margin:0, letterSpacing:'0.05em' }}>Acceso restringido — Vista previa interna</p>
      <div style={{ display:'flex', gap:'8px' }}>
        <input
          type="password"
          placeholder="Contraseña"
          value={val}
          onChange={e => { setVal(e.target.value); setErr(false); }}
          onKeyDown={e => e.key === 'Enter' && check()}
          autoFocus
          style={{ padding:'10px 16px', background:'rgba(255,255,255,0.05)', border: err ? '1px solid #FF4D00' : '1px solid rgba(255,255,255,0.12)', borderRadius:'4px', color:'#F9FAF6', outline:'none', fontSize:'14px', width:'220px' }}
        />
        <button onClick={check} style={{ padding:'10px 22px', background:'#FF4D00', color:'#fff', border:'none', borderRadius:'4px', cursor:'pointer', fontWeight:700, fontSize:'13px' }}>
          Entrar
        </button>
      </div>
      {err && <p style={{ color:'#FF4D00', fontSize:'12px', margin:0 }}>Contraseña incorrecta</p>}
    </div>
  );
}

const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.role === 'admin' ? children : <Navigate to="/" />;
};

const ProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user ? children : <Navigate to="/login" />;
};

function LandingRoute({ children }) {
  return <LangProvider>{children}</LangProvider>;
}

function App() {
  return (
    <PasswordGate>
    <ThemeProvider>
      <AuthProvider>
        <MLMProvider>
          <AdminProvider>
            <Router>
              <Routes>
                <Route path="/" element={<LandingRoute><HomePage /></LandingRoute>} />
                <Route path="/nosotros" element={<LandingRoute><LandingNosotros /></LandingRoute>} />
                <Route path="/contacto" element={<LandingRoute><LandingContacto /></LandingRoute>} />
                <Route path="/mercados-emergentes" element={<LandingRoute><LandingMercadosEmergentes /></LandingRoute>} />
                <Route path="/centro-de-ayuda" element={<LandingRoute><LandingCentroAyuda /></LandingRoute>} />
                <Route path="/legal/legales-generales" element={<LandingRoute><LandingLegalesGenerales /></LandingRoute>} />
                <Route path="/legal/privacidad" element={<LandingRoute><LandingPrivacidad /></LandingRoute>} />
                <Route path="/legal/terminos-condiciones" element={<LandingRoute><LandingTerminosCondiciones /></LandingRoute>} />
                <Route path="/legal/cookies" element={<LandingRoute><LandingCookies /></LandingRoute>} />
                <Route path="/legal/envios-devoluciones" element={<LandingRoute><LandingEnviosDevoluciones /></LandingRoute>} />
                <Route path="/legal/codigo-etica" element={<LandingRoute><LandingCodigoEtica /></LandingRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<RegisterPremium />} />
                <Route path="/register/gestor" element={<RegisterGestor />} />
                <Route path="/set-password" element={<SetPassword />} />

                <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/network" element={<Network />} />
                  <Route path="/commissions" element={<Commissions />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/orders" element={<OrderHistory />} />
                  <Route path="/mlm" element={<MLMDashboard />} />
                  <Route path="/mlm/binary-tree" element={<BinaryTree />} />
                  <Route path="/mlm/unilevel-tree" element={<UnilevelTree />} />
                  <Route path="/mlm/rank-progression" element={<RankProgression />} />
                  <Route path="/mlm/wallet" element={<WalletPage />} />
                  <Route path="/mlm/sttora-points" element={<SttoraPointsPage />} />
                  <Route path="/mlm/global-pool" element={<GlobalPoolPage />} />
                </Route>

                <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="users" element={<UserManagement />} />
                  <Route path="network" element={<AdminNetworkView />} />
                  <Route path="commissions" element={<CommissionSettings />} />
                  <Route path="payouts" element={<PayoutManagement />} />
                  <Route path="products" element={<ProductManagement />} />
                  <Route path="categories" element={<AdminCategories />} />
                  <Route path="subcategories" element={<AdminSubcategories />} />
                  <Route path="families" element={<AdminFamilies />} />
                  <Route path="packs" element={<AdminPacks />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="reports" element={<SystemReports />} />
                  <Route path="settings" element={<SystemSettings />} />
                </Route>

                <Route path="/admin/mlm" element={<ProtectedRoute><AdminMLM /></ProtectedRoute>} />
                <Route path="/admin/mlm/users/:userId/network" element={<ProtectedRoute><UserNetworkView /></ProtectedRoute>} />

                <Route path="/store" element={<StoreLayout />}>
                  <Route index element={<StoreHome />} />
                  <Route path="categories" element={<AllCategories />} />
                  <Route path="categories/:slug" element={<CategoryProducts />} />
                  <Route path="featured" element={<FeaturedProducts />} />
                  <Route path="search" element={<SearchResults />} />
                  <Route path="products/:id" element={<ProductDetail />} />
                  <Route path="packs" element={<StorePacks />} />
                  <Route path="packs/:id" element={<StorePackDetail />} />
                  <Route path="cart" element={<Cart />} />
                  <Route path="checkout" element={<Checkout />} />
                  <Route path="checkout/stripe/:orderId" element={<StripeCheckout />} />
                  <Route path="orders/:orderId/confirmation" element={<OrderConfirmation />} />
                </Route>
              </Routes>
            </Router>
          </AdminProvider>
        </MLMProvider>
      </AuthProvider>
    </ThemeProvider>
    </PasswordGate>
  );
}

export default App;
